import styled from 'styled-components'

import { Box, Text } from '@usap/uicomponents'

export const SummaryContainer = styled(Box)`
  background: #fff;
  border: #D4D4D6 1px solid;
  border-radius: 4px;
  padding: 16px;
  gap: 16px;
  align-self: start;

  position: relative;
`

export const SummaryHeader = styled('header')`
  border-bottom: #bebec1 solid 1px;
  padding-bottom: 16px;
`

export const SummaryTitle = styled('h4')`
  color: #333;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  margin: 0;
  margin-bottom: 8px;
`

export const SummaryQuantity = styled('span')`
  color: #5E5E65;
  font-weight: 400;

  &:before {
    content: ' ';
  }
`

export const SummaryShippingTo = styled(Text)`
  color: #333;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`

export const SummaryShippingToLocation = styled('u')`
  font-weight: 700;
  cursor: pointer;
`

export const SummaryTorso = styled(Box)`
  gap: 8px;
`

export const SummaryTorsoWidget = styled(Box)`
  gap: 12px;
`

export const SummaryExtraItemsContainer = styled(Box)`
  gap: 4px;
`

export const SummaryExtraItemStyle = styled(Text)`
  color: #5E5E65;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`

export const SummaryNegativeItemValue = styled('span')`
  color: #669944;
`

export const SummaryDarkerItem = styled(Text)`
  color: #282828;
  font-size: 14px;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
`
